import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  items: localStorage.getItem("carts")
    ? JSON.parse(localStorage.getItem("carts"))
    : [],
  statusTab: false,
  addresses: [],
  orderdetails: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart(state, action) {
      const { productId, quantity, price } = action.payload;
      const indexProductId = state.items.findIndex(
        (item) => item.productId === productId
      );
      if (indexProductId >= 0) {
        state.items[indexProductId].quantity += quantity;
      } else {
        state.items.push({ productId, quantity, price });
      }
      localStorage.setItem("carts", JSON.stringify(state.items));
    },

    clearCart(state, action) {
      state.items = [];
      localStorage.removeItem("carts", JSON.stringify(state.items));
    },

    ChangeQuantity(state, action) {
      const { productId, quantity } = action.payload;
      const indexProductId = state.items.findIndex(
        (item) => item.productId === productId
      );
      if (quantity > 0) {
        state.items[indexProductId].quantity = quantity;
      } else {
        // delete state.items[indexProductId];
        state.items = state.items.filter(
          (item) => item.productId !== productId
        );
      }
      localStorage.setItem("carts", JSON.stringify(state.items));
    },

    addAddress(state, action) {
      const { address, city, postcode, country, telephone } = action.payload;
      state.addresses = { address, city, postcode, country, telephone };
      // localStorage.setItem("carts", JSON.stringify(state.items));
    },

    addOrder(state, action) {
      const {
        id,
        paymentmethod,
        totalprice,
        ispaid,
        paidat,
        isdelivered,
        deliveredat,
      } = action.payload;
      state.orderdetails = {
        id,
        paymentmethod,
        totalprice,
        ispaid,
        paidat,
        isdelivered,
        deliveredat,
      };
    },

    toggleStatusTab(state) {
      if (state.statusTab === false) {
        state.statusTab = true;
      } else {
        state.statusTab = false;
      }
    },
  },
});
export const {
  addToCart,
  ChangeQuantity,
  toggleStatusTab,
  GetOrderTotal,
  addOrder,
  addAddress,
  clearCart,
} = cartSlice.actions;
export default cartSlice.reducer;
